/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Featuremultisubjectdesc3Inputs */

const zh_about_featuremultisubjectdesc3 = /** @type {(inputs: About_Featuremultisubjectdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数学动画、物理实验、语文赏析、英语对话——覆盖主要学科，满足教学全场景需求。`)
};

const en_about_featuremultisubjectdesc3 = /** @type {(inputs: About_Featuremultisubjectdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Math animations, physics experiments, literary analysis, English conversations — covering major subjects to meet every teaching scenario.`)
};

const es_about_featuremultisubjectdesc3 = /** @type {(inputs: About_Featuremultisubjectdesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Animaciones de matemáticas, experimentos de física, análisis literario, conversaciones en inglés: cubriendo las principales materias para cada escenario educativo.`)
};

/**
* | output |
* | --- |
* | "Math animations, physics experiments, literary analysis, English conversations — covering major subjects to meet every teaching scenario." |
*
* @param {About_Featuremultisubjectdesc3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const about_featuremultisubjectdesc3 = /** @type {((inputs?: About_Featuremultisubjectdesc3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Featuremultisubjectdesc3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_about_featuremultisubjectdesc3(inputs)
	if (locale === "en") return en_about_featuremultisubjectdesc3(inputs)
	return es_about_featuremultisubjectdesc3(inputs)
});
export { about_featuremultisubjectdesc3 as "about_featureMultiSubjectDesc" }